import React from 'react';
import PropTypes from 'prop-types';
import { Control } from 'react-redux-form';
import {
  Row,
  Col,
  Button,
  ControlLabel
} from 'react-bootstrap';
import { LocalForm } from 'react-redux-form';

const RadioButtonFieldComponent = ({
  onSubmit,
  isDisabled,
  submitLabel,
  options,
  defaultOption,
}) => {
  return (
    <Row>
      <LocalForm
        id="job-info-form"
        initialState={{ selected: defaultOption }}
        onSubmit={onSubmit}
      >
        <Button className="form-control" type="submit" disabled={isDisabled}>
          {submitLabel}
        </Button>
        <Col mdOffset={1}>
          { options.map(option =>
            <Row key={option}>
              <ControlLabel> {option.toUpperCase()} </ControlLabel>
              <Control.radio
                id={`radio-${option}`}
                value={option}
                model=".selected"
              />
            </Row>
          )}
        </Col>
      </LocalForm>
    </Row>
  );
};

RadioButtonFieldComponent.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  isDisabled: PropTypes.bool.isRequired,
  submitLabel: PropTypes.string.isRequired,
  options: PropTypes.arrayOf(PropTypes.string).isRequired,
  defaultOption: PropTypes.string.isRequired
};

export default RadioButtonFieldComponent;


// WEBPACK FOOTER //
// src/Components/RadioButtonFieldComponent.jsx